import { Component, Injectable, Input, OnChanges } from '@angular/core';

import { AlertService } from '../../../../../app/utils/alert.service';
import { OperationsReportService } from '../../../../../app/services/reports.operations.service';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { OperationReport } from '../../../../../app/models/reports.operation.model';
import { OperationCategory } from '../../../../../app/models/reports.operation.category.model';
import { OperationEvent } from '../../../../../app/models/reports.operation.event.model';
import { Filter } from '../../../../../app/models/filter.model';

  import * as _ from "lodash";
  import * as moment from 'moment';

/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 92819 2018-05-30 18:22:26Z bernardo.d.siqueira $
 */
@Component({
  selector: 'operationsReport',
  templateUrl: './content.template.html'
})
@Injectable()
export class OperationsReportComponent implements OnChanges {

  private static readonly FETCH_SIZE: number = 50;

  private categories: OperationCategory[] = [];
  private selectedCategory: OperationCategory;
  private filter: Filter;

  @Input() startDate: Date;
  @Input() endDate: Date;

  constructor(private operationReportService: OperationsReportService, private alertService: AlertService, private bindComponent: BindComponentService) {

  }

  ngOnInit() {
    this.bindComponent.subscribe(BindComponentService.FILTER_REPORT_OPERATION,
     filter => {
        this.doFilter(filter);
      }
    );
  }

  ngOnChanges() {
    if (this.validateDate()) {
      this.loadView();
    } else {
      this.categories = [];
      this.selectedCategory = null;
    }
  }

  private loadView() {
    this.operationReportService.listOperationCategories().subscribe(
      data => {
        let dataCategories:any = <any> data;
        this.categories = dataCategories;
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return "";
    }
    if (msisdn.length === 12) {
      return "("
        .concat(msisdn.substr(0, 3))
        .concat(") ")
        .concat(msisdn.substring(3, msisdn.length - 4))
        .concat("-")
        .concat(msisdn.substr(-4, 4));
    } else if (msisdn.length === 11) {
      return "("
        .concat(msisdn.substr(0, 2))
        .concat(") ")
        .concat(msisdn.substring(2, msisdn.length - 4))
        .concat("-")
        .concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }

  private formatDate(date: Date) {
    return (!this.validateDate()) ? '' : moment(date).format('DD/MM/YYYY');
  }

  private formatDateTime(date: Date) {
    return (!this.validateDate()) ? '' : moment(date).format('DD/MM/YYYY - HH:mm');
  }

  private setEvents(category: OperationCategory, events: OperationEvent[]) {
    category.events = [];
    Array.prototype.push.apply(category.events, events);
  }

  private validateDate(): boolean {
    let valid: boolean = true;
    if (!this.startDate || !this.endDate || !this.startDate == null || !this.endDate == null) {
      valid = false;
    }
    return valid;
  }

  private toggleCategory(category: OperationCategory) {
    if(!this.selectedCategory || this.selectedCategory.id !== category.id) {
      this.selectedCategory = category;
      if (!this.validateDate()) {
        this.alertService.warn('Preencha o período de pesquisa');
        category.events = [];
        return;
      }
      this.loadEvents(category);
    } else {
      this.selectedCategory = null;
    }
  }

  private loadEvents(category: OperationCategory) {
    this.operationReportService.listOperationEvents(category.id, this.startDate, this.endDate, 1, OperationsReportComponent.FETCH_SIZE).subscribe(
      data => {
        let dataEvent:any = <any> data;
        this.setEvents(category, dataEvent);
        this.doFilter(null);
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  public doFilter(newFilterValue: Filter) {
    this.filter = newFilterValue;
    if (this.selectedCategory && this.selectedCategory != null && this.selectedCategory.events.length > 0) {
      this.selectedCategory.events.forEach(eventItem => {
        let eventItemFiltered = (this.filter === undefined || this.filter == null || this.filter.value === '') || this.searchText(this.filter.value, eventItem.name);
        eventItem.filtered = eventItemFiltered;
      });
    }
  }
  
  private downloadFile(category: OperationCategory){
	  if (this.selectedCategory && this.selectedCategory != null && this.selectedCategory.events.length > 0) {
		  this.operationReportService.generateReport(this.selectedCategory.id, this.selectedCategory.name, this.startDate, this.endDate, 1, 100000);
	  } else {
		  this.alertService.warn('Selecione uma categoria.');
	  }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/operations/content.component.ts